<template>
  <section id="aboutAsSection" class="main-banner">
    <b-container>
      <b-row class="align-content-center">
        <b-col sm="12" md="4" lg="4">
          <div class="banner-img-container">
            <img src="../../assets/img/tree.svg" alt="Main banner">
          </div>
        </b-col>
        <b-col sm="12" md="8" lg="8">
          <div class="banner-container-content">
            <div>
              <h1 class="banner-title" v-html="$t('banner_title')"></h1>
              <p class="banner-subtitle" v-html="$t('banner_subtitle')"></p>
            </div>
            <p class="banner-text-content" v-html="$t('banner_text')"></p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/app.scss";
  .main-banner{
    @media screen and (min-width: 320px) {
      padding-top: 40px;
      padding-bottom: 40px;
    }
    @media screen and (min-width: 768px) {
      padding-top: 80px;
      padding-bottom: 80px;
    }
    @media screen and (min-width: 1440px) {
    }
    @media screen and (min-width: 1920px) {
    }
    .banner-img-container{
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 100%;
          height: auto;
          @media screen and (min-width: 320px) {
            max-width: 165px;
          }
          @media screen and (min-width: 768px) {
          }
          @media screen and (min-width: 1440px) {
            max-width: 255px;
          }
          @media screen and (min-width: 1920px) {
          }
        }
    }
    .banner-container-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding-top: 64px;
      gap: 40px;
      font-family: $main-font;
      color: #000;
      @media screen and (min-width: 320px) {
        padding-top: 40px;
        gap: 24px;
      }
      @media screen and (min-width: 768px) {
        padding-top: 0;
        justify-content: center;
      }
      @media screen and (min-width: 1440px) {
        padding-top: 64px;
        justify-content: flex-start;
      }
      @media screen and (min-width: 1920px) {
      }
      .banner-title{
        font-size: 80px;
        font-style: normal;
        font-weight: 800;
        line-height: 96px;
        letter-spacing: 1px;
        text-transform: uppercase;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 48px;
          line-height: 57.6px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 1440px) {
          font-size: 80px;
          line-height: 96px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .banner-subtitle{
        font-style: normal;
        line-height:  57.6px;
        margin: 0;
        @media screen and (min-width: 320px) {
          font-size: 24px;
          line-height: 28.8px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 1440px) {
          font-size: 48px;
          font-weight: 700;
        }
        @media screen and (min-width: 1920px) {
        }
      }
      .banner-text-content{
        font-weight: 600;
        font-style: normal;
        line-height: 33.6px;
        @media screen and (min-width: 320px) {
          font-size: 16px;
          line-height: 22.4px;
        }
        @media screen and (min-width: 768px) {
        }
        @media screen and (min-width: 1440px) {
          font-size: 24px;
          line-height: 33.6px;
        }
        @media screen and (min-width: 1920px) {
        }
      }
    }
  }
</style>
